// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.container {
  max-width: 240px;
  width: 240px;
  z-index: 20004 !important;

  display: flex;
  position: absolute;
  left: 10px;
  bottom: 10px;
  padding: 5px;
  border-radius: 5px;
  color: #f6f6f6;
  background: white;
  color: #d7d7d7;
  
  background: #333333;
  cursor: pointer;
}
.section {
  padding: 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
  `, "",{"version":3,"sources":["webpack://./src/app/services/payment.service.ts"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;;EAEzB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,cAAc;;EAEd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":["\n.container {\n  max-width: 240px;\n  width: 240px;\n  z-index: 20004 !important;\n\n  display: flex;\n  position: absolute;\n  left: 10px;\n  bottom: 10px;\n  padding: 5px;\n  border-radius: 5px;\n  color: #f6f6f6;\n  background: white;\n  color: #d7d7d7;\n  \n  background: #333333;\n  cursor: pointer;\n}\n.section {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
